<p-card
  styleClass="very-compact-card"
  header="История">
  <crm-spinner
    *ngIf="loadingHistory"
    top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
  <ng-container *ngIf="!loadingHistory">
    <div
      *ngIf="historyItems?.length; else notData"
      class="px-3 pb-3 max-h-29rem overflow-auto"
      (scroll)="onScrollEndHistory($any($event.target))">
      <p-timeline
        [value]="historyItems | orderBy: '-created:date'"
        styleClass="history-timeline mt-3">
        <ng-template
          pTemplate="content"
          let-event>
          <ng-container *ngIf="toItem(event) as event">
            <div class="flex -mt-2 mb-4">
              <crm-user-avatar
                *ngIf="event.user"
                [user]="event.user"></crm-user-avatar>
              <crm-user-avatar
                *ngIf="!event.user"
                [user]="{ id: -1, profile: { id: -1, name: 'ФРМ', file: null } }"></crm-user-avatar>
              <div class="w-full ml-3">
                <div class="font-medium">{{ event.user?.profile?.name || 'ФРМ' }}</div>
                <div class="text-400 text-sm">{{ event.created | date: 'dd.MM.yyyy HH:mm' }}</div>
                <div class="mt-2">
                  <p>{{ event?.label }}</p>
                  <p *ngIf="event?.oldValue">{{ event.oldValue }}</p>
                  <p *ngIf="event?.newValue">{{ event.newValue }}</p>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </p-timeline>

      <div
        *ngIf="paginationLoadingHistory"
        class="text-center">
        <p-progressSpinner
          [style]="{
            width: '50px',
            height: '50px'
          }"></p-progressSpinner>
      </div>
    </div>

    <ng-template #notData>
      <p class="text-xl font-medium ml-1 p-3">Нет данных</p>
    </ng-template>
  </ng-container>
</p-card>
